export default __webpack_public_path__ + "static/media/right-camera.b4f7acf5.gif";